export default __webpack_public_path__ + "static/media/nokia.2db20fb1.png";